import React, { useEffect, useMemo, useState } from "react";
// import { useWhatChanged } from "@simbathesailor/use-what-changed";

import { Button, Dropdown, Icon } from "semantic-ui-react";

const ClinicalFindingsMenu = (props) => {
  const [menuList, setMenuList] = useState({});
  console.log(" ClinicalFindingsMenu props.clinicalFinding: ", props.clinicalFinding?.clinicaltags )

  useEffect(() => {
    let list = {};
    let tags = null;
    if (props.controller?.data?.clinicaltags?.items) {
      console.log("Menu options:", props.controller.data.clinicaltags)
      if (props.activeIndexDiagram === 0) {
        tags = props.controller?.data?.clinicaltags?.items?.filter( item => item.diagram === "teeth");
      } else {
        tags = props.controller?.data?.clinicaltags?.items?.filter( item => item.diagram !== "teeth");
      }

      let groups = tags.filter((item) => item.is_group);

      console.log(
        " props.controller?.data?.clinicaltags: ",
        props.controller?.data?.clinicaltags
      );
      // Prepare default Menu
      groups.forEach((group) => {
        // console.log("element ", group);
        let detail = tags
          .filter((item) => item.group === group.name)
          // .filter((item) => item.detail)
          .map((item) => {
            return { ...item, selected: false };
          });
        // console.log("detail ", detail);
        list[group.name] = detail;
      });

      // Add selcted Menu
      if (props.clinicalFinding?.clinicaltags) {
        let clinicaltags = props.clinicalFinding?.clinicaltags;
        console.log(" clinicaltags", clinicaltags)
        let ctlist = clinicaltags.split(",").map((item) => item.trim());
        console.log("ctlist", ctlist);

        groups.forEach((group) => {
          let detail = list[group.name].map((item) => {
            console.log(
              " Check inside ctlist.includes(item.name): ",
              ctlist.includes(item.name)
            );
            return {
              ...item,
              selected: ctlist.includes(item.name) ? true : false,
            };
          });
          list[group.name] = detail;
        });
      }
    }
    console.log(" !!!!!!!! list ", list);
    setMenuList(list);
  }, [
    props.controller,
    props.controller.data.clinicaltags,
    props.clinicalFinding.clinicaltags,
    props.activeIndexDiagram, 
  ]);

  // const [menuList, menuState] = useMemo(() => {
  //   // console.log(" Expensive compute menuList");
  //   let list = {};
  //   let stateList = {};
  //   if (props.controller?.data?.clinicaltags?.items) {
  //     let tags = props.controller?.data?.clinicaltags?.items;
  //     let groups = tags.filter((item) => !item.detail);
  //     // console.log(" tags: ", tags, " ,group:", groups);
  //     groups.forEach((group) => {
  //       // console.log("element ", group);
  //       let detail = tags
  //         .filter((item) => item.group === group.name)
  //         .filter((item) => item.detail);
  //       // console.log("detail ", detail);
  //       list[group.name] = detail;
  //     });
  //   }
  //   // console.log(" list", list);
  //   return [list, stateList];
  // }, [props.controller, props.controller.data.clinicaltags]);

  // console.log(
  //   "ClinicalFindingsMenu props.controller",
  //   props.controller.data.clinicaltags,
  //   "menuList",
  //   menuList
  // );
  return (
    <div
      className={"clinical-findings-menu "}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
 
      {Object.entries(menuList).map((item, i) => {
        console.log("key", item, "i", i);
        return <ClinicalTag key={i} groups={item[0]} options={item[1]} onEvent={props.onEvent} />;
      })}
    </div>
  );
};

const ClinicalTag = React.memo((props) => {
  const [open, setOpen] = useState(false);

  // console.log("ClinicalTag ", props);
  let colorList = props.options?.find(item => item.name === props.groups).colors

  let primaryColor  = colorList[0]
  let secondaryColor = ""
  if (colorList?.length > 1) {
    secondaryColor = colorList[1]
  }

  // console.log(" primaryColor: ",primaryColor, "secondaryColor: ", secondaryColor )

  return (
    <Button.Group size="tiny" color={primaryColor} style={{marginRight: "10px"}}>
      <Button 
        onClick={() => {
          console.log(" props", props)
          props.onEvent({message: "ToggleClinicalTags", params: {name: props.groups, diagram: props.options[0].diagram}})
        }}
        style={ { ...( secondaryColor && {border: "3px solid " + secondaryColor })} }>
          {props.groups === "Missing" && <Icon name="close"/>}
          {props.groups}
          </Button>
        {props.options?.filter(item => !item.is_group).length > 0 ? (
        <Dropdown
          className="button icon"
          floating
          // options={ item[1].map( option => { return { key: option.name, text: option.name, value: option.name}} )}
          trigger={<></>}
          onClick={(e, data) => {
            // console.log("onClick e.target", e.target, "data", data)
            e.preventDefault();
            if (!open) {
              setOpen(true);
            }
          }}
          open={open}
          onBlur={(e) => {
            setOpen(false);
          }}
          onClose={(e) => {
            if (!e?.target) {
              setOpen(false);
            }
          }}
        >
          <Dropdown.Menu>
            <Dropdown.Item 
              style={{marginTop: "7px"}}   
              onClick={(e, data) => {
                console.log("Item Click type of ct!! ", e, "data", data)
                props.onEvent({message: "ToggleClinicalTags", params: {name: data.text,  diagram: props.options[0].diagram}})
              }}
              text={props.groups}
              label={{
                  color: props.options.find(item => item.name === props.groups).selected? "red" : "grey" , 
                  empty: true,
                  circular: true
                }}
              />
              {/* <Icon
                name="circle"
                color={ props.options.find(item => item.name === props.groups).selected ? "red" : "grey"}

              /> */}
            <Dropdown.Divider />
            {props.options
              .filter((item) => !item.is_group)
              .map((options) => {
                return (
                  <Dropdown.Item
                    onClick={(e, data) => {
                      console.log('data: ', data);
                      
                      props.onEvent({ message: "ToggleClinicalTags", params: {name: data.text,  diagram: options.diagram} })
                    }}
                    label={{
                      color: options.selected ? "red" : "grey",
                      empty: true,
                      circular: true,
                    }}
                    text={options.name}
                  />
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
    </Button.Group>
  );
});

export default ClinicalFindingsMenu;
